import script from "./TermsAndPolicy.vue?vue&type=script&setup=true&lang=js"
export * from "./TermsAndPolicy.vue?vue&type=script&setup=true&lang=js"

import "./TermsAndPolicy.vue?vue&type=style&index=0&id=e74b4906&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e74b4906"]])

export default __exports__